import { css, html } from "lit";
import { prop } from "../../../decorators/prop/index.js";
import { BaseComponent } from "../../BaseComponent.js";
import { defineElement } from "../../../decorators/defineElement.js";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result) __defProp(target, key, result);
  return result;
};
let DsfCount = class extends BaseComponent {
  constructor() {
    super(...arguments);
    this.dsf_count = 0;
  }
  get count() {
    return this.dsf_count > 99 ? "99+" : this.dsf_count;
  }
  render() {
    return html`<div
      class="dsf-text-xxs flex h-16 min-w-16 items-center justify-center rounded-full bg-error-100 px-4 text-error-600"
      title=${this.dsf_count}
      data-skeleton
    >
      ${this.count}
    </div>`;
  }
};
DsfCount.shadowRootOptions = {
  ...BaseComponent.shadowRootOptions,
  delegatesFocus: false
};
DsfCount.styles = [
  ...BaseComponent.styles,
  css`
      :host {
        display: inline-flex;
      }
    `
];
__decorateClass([
  prop({ type: Number })
], DsfCount.prototype, "dsf_count", 2);
DsfCount = __decorateClass([
  defineElement("dsf-count")
], DsfCount);
export {
  DsfCount
};
